<template>
  <section class="presentercta general" id="presenter">
    <div class="presentercta__banner">
      <div class="presentercta__banner--content container">
        <div class="presentercta__single-card">
          <div class="text">
            <h2 class="title">Become a Presenter</h2>
            <p class="description">
              Presenters will have access to DNA HOUSE full day on the day of their presentation, which includes:
            </p>
            <ul>
              <li>
                <img src="@/assets/icons/check-dark.png" alt="icon" class="icon" />
                Scheduled investor/partner meetings
              </li>
              <li>
                <img src="@/assets/icons/check-dark.png" alt="icon" class="icon" />
                Access to Event
              </li>
              <li>
                <img src="@/assets/icons/check-dark.png" alt="icon" class="icon" />
                Represent your Brand
              </li>
            </ul>
          </div>
          <div class="btn">
            <a href="mailto:sponsors@dna.fund?subject=I want to present in DNA House" target="_blank">
              <button class="button present-btn">Inquiry to Present</button>
            </a>
          </div>
          <div class="btn-alt">
            <img src="@/assets/icons/video.png" alt="Video Icon">
            <a href="https://www.youtube.com/@dna_fund" target="_blank">
              View Presentations
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/presentercta.scss';
</style>

<script>

export default {
  name: 'presentercta',
  components: {
    
  },
  data() {
    return {
    };
  },
};
</script>